// extracted by mini-css-extract-plugin
module.exports = {"parent":"properties_parent__3TXjl","mainText":"properties_mainText__hk3C7","properties":"properties_properties__3XMnR"};